/* eslint-disable react/jsx-filename-extension */
import "./styles/index.css";

import React from "react";

import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { Notification } from "./components/Notification";
import store, { persistor } from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import Router from "./router";
console.log("Backend Host:", process.env.REACT_APP_BACKEND_HOST);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Router />
        {/* <RouterProvider router={router} /> */}
        <Notification />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
